// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "dayOfWeekName-13HYD";
var _3 = "dayOfWeekName_withPrices-sreYC";
export { _1 as "__esModule", _2 as "dayOfWeekName", _3 as "dayOfWeekName_withPrices" }
export default { "__esModule": _1, "dayOfWeekName": _2, "dayOfWeekName_withPrices": _3 }
